import React, { lazy } from 'react';
import { connect } from 'react-redux';
import * as formsAction from "../../redux/actions/formsAction";
import ControlService from "../../helper/controlservice";
import Modal from 'react-modal';
import DynamicformInit from "../DynamicformInit";
import Loading from '../../helper/component/Loading';
import DynamicFormControls from "../DynamicForm/DynamicFormControls";
import { toast } from 'react-toastify';
import Message from "../../helper/component/Message";
import { renderNoDataImage } from "../../helper/common/advanceGrid";

const _ = require('lodash');
const RefreshApiFields = lazy(() => import('../../helper/component/RefreshApiFields'))

const uuidv4 = require('uuid/v4');

function mapStateToProps(state) {
    return {
        data: state.formDataReducer,
        token: state.formLoginReducer.token,
        hasErrored: state.formDataReducer.hasErrored,
        isLoading: state.formDataReducer.isLoading,
        sidebarFormName: state.formDataReducer.sidebarFormName
    };
}

function bindAction(dispatch) {
    return {
        setPageParams: (data) => dispatch(formsAction.setPageParams(data)),
        resetData: (data, storekey) => dispatch(formsAction.resetFormData(data, storekey)),
        update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey))
    };
}

class GridUI extends React.PureComponent {
    state = {
        Iscontrolladded: false,
        sidebar: false,
        isShow: {},
        modalIsOpen: false,
        rowId: null,
        _opened: false,
        cardForm: null,
        CustomCardsData: [],
        checklistData: [],
        AddEditForm: {},
        AddEditFormModelJson: {},
        isApiCalling: false,
        data: [],
        refreshMessage: "",
        isReviewer: false,
        validationFailed: false,
        sortedfield: {}
    }
    static getDerivedStateFromProps(nextProps) {
        if (nextProps.control.viewtype !== 'list') {
            var _data = nextProps.data[nextProps.formid] && Array.isArray(nextProps.data[nextProps.formid][nextProps.control.key]) ? nextProps.data[nextProps.formid][nextProps.control.key] : [];
            var Items = [];
            _data.forEach((row) => {
                let _row = nextProps.data[row.id + 'write'];
                if (_row) {
                    _row.id = row.id;
                    Items.push(_row);
                }
            })
            // if (_data && Items.length > 0 && _data.length == Items.length && JSON.stringify(Items) != JSON.stringify(_data)) {
            return { data: Items.length > 0 ? Items : _data };
            // } else return null;
        }
        else return { data: nextProps.data[nextProps.formid] && Array.isArray(nextProps.data[nextProps.formid][nextProps.control.key]) ? nextProps.data[nextProps.formid][nextProps.control.key] : [] };
    }
    componentDidUpdate(prevProps, prevState) {
        const { control, formid } = this.props;
        var data = this.props.data[this.props.formid] && Array.isArray(this.props.data[this.props.formid][this.props.control.key]) ? this.props.data[this.props.formid][this.props.control.key] : [];
        if (Array.isArray(this.state.data) && JSON.stringify(this.state.data) != JSON.stringify(prevState.data)) {
            var _data = this.state.data;
            if (control.viewtype == 'list') {
                this.storeCustomCardsData(_data);

                this.setState({ CustomCardsData: _data })
            }
            else if (Array.isArray(_data) && Array.isArray(data) && JSON.stringify(_data) != JSON.stringify(data)) {
                this.props.update(control.key, _data, formid);
            } else {
                this.InitializeControl(_data);
            }
            if (this.isAddDisabled()) {
                this.controlVaildationCheck(null);
            } else {
                this.setState({ validationFailed: false }, () => this.controlVaildationCheck(_data));
            }
        }
    }

    componentDidMount() {
        debugger;
        const { control, formid } = this.props;
        // this.setState({ FieldMappings: ControlService().setMappingFields(this.props.control) });
        var data = this.props.data[formid] && Array.isArray(this.props.data[formid][control.key]) ? this.props.data[formid][control.key] : [];
        if (data.length === 0 && control.defaultitemonload > 0) {
            let nums = _.range(control.defaultitemonload);
            for (let num of nums) {
                let row = {};
                row.id = uuidv4();
                this.Addrow(control, formid);
                this.props.resetData(row, row.id + 'write');
            }
        }
        if (control.viewtype == 'list') {
            this.storeCustomCardsData(data);
            // this.props.resetData(data, formid)
            this.setState({ CustomCardsData: data })
            this.setState({})
            this.loadCardUI(control);
            this.loadAddEditFormUI(control);
        } else {
            this.InitializeControl(data);
        }
        this.controlVaildationCheck(data);
    }
    storeCustomCardsData(data) {
        const { control } = this.props;
        if (control.viewtype == 'list' && Array.isArray(data)) {

            data.map(item => {
                item.cameoCardUniqueKey = uuidv4();
                this.props.resetData(item, item.cameoCardUniqueKey + 'write');

                return item;
            })
        }
    }
    loadCardUI(control) {
        this.setState({ isApiCalling: true, CardForm: null });
        if (control.cardformid) {
            ControlService().loadMetadata(control.cardformid, this.props.token)
                .then(
                    (data) => {
                        this.setState({ CardForm: data, isApiCalling: false })

                    })
                .catch(() => {
                    this.setState({ isApiCalling: false });
                });
        }
    }
    loadAddEditFormUI(control) {
        this.setState({ isApiCalling: true });
        ControlService().loadMetadata(control.addeditformid, this.props.token)
            .then(
                (data) => {
                    this.setState({
                        AddEditForm: data,
                        AddEditFormModelJson: ControlService().deepcopy(data.ModelJson), isApiCalling: false
                    })

                })
            .catch(() => {
                this.setState({ isApiCalling: false });
            });
    }
    InitializeControl(data) {
        // const { data } = this.state;
        this.props.resetData(null, this.state.AddEditForm.Id + "write_validation");
        if (Array.isArray(data)) {
            for (let row of data) {
                if (!row.id) {
                    row.id = uuidv4();
                }
                this.props.resetData(row, row.id + 'write');
            }
        }
        this.setState({ Iscontrolladded: true });
    }
    callAddControll() {
        if (this.state.data) {
            this.state.data.forEach(() => {
                // this.addChildControlsInit(this.props.control.children, opt.id);
                this.setState({ Iscontrolladded: true });
            });
        }
    }
    controlVaildationCheck(_data) {
        const { control, formid, data } = this.props;
        var validation = ControlService().validate(control, _data);

        var _dataValidation = data[formid + "_validation"] && data[formid + "_validation"][control.key] ? data[formid + "_validation"][control.key] : {}

        if (validation && !this.state.validationFailed) {
            if (_dataValidation.status != 'pass')
                this.props.update(control.key, { "status": "pass", "control": control, touched: false }, this.props.formid + "_validation")
        } else if (_dataValidation.status != 'fail') {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation")
        }
    }
    isAddDisabled() {
        const { data } = this.props;
        var grid_data = Array.isArray(this.state.data) ? this.state.data : [];
        var formvalid = true;
        grid_data.some(function (row) {
            const formvalidation = data[row.id + "write_validation"];
            if (formvalidation && formvalid) {
                var arr = [];
                Object.keys(formvalidation).forEach(
                    (key) => {
                        const value = formvalidation[key] ? formvalidation[key] : {};
                        arr.push({ "key": key, "value": value.status, "control": value.control });
                    }
                );
                const isValid = arr.filter(item => item.value == 'fail');
                if (arr.length == 0) {
                    formvalid = true;
                } else {
                    if (arr.length > 0 && isValid.length == 0) {
                        formvalid = true;
                    }
                    else {
                        formvalid = false;
                    }
                }
            } else {
                return true;
            }
        });

        return !formvalid;
    }
    MoveRow(RowId, down) {
        const { control, formid } = this.props;
        debugger;
        var data = Array.isArray(this.state.data) ? this.state.data : [];
        var index1 = data.findIndex(x => x.id === RowId);
        var index2 = 0;
        if (down) {
            index2 = index1 + 1;
        } else {
            index2 = index1 - 1;
        }
        if (index1 > -1 && index2 > -1 && index2 < data.length) {
            [data[index1], data[index2]] = [data[index2], data[index1]]

            this.props.update(control.key, data, formid);
        }
    }
    Addrow(control, formid) {
        debugger;
        if (this.isAddDisabled()) {
            this.setState({ validationFailed: true });
            return;
        }
        this.setState({ Iscontrolladded: true, validationFailed: false });
        var data = Array.isArray(this.state.data) ? this.state.data : [];
        var datarow = {};

        let uuid = uuidv4();

        this.GenerateDataJson(control.children, datarow);
        // this.props.update("id", uuid, uuid);
        datarow["id"] = uuid;
        if (control.addrootattributes && Array.isArray(control.rootattributes)) {
            var formData = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {};
            control.rootattributes.map(key => {
                datarow[key] = formData[key];
            });
        }
        this.props.resetData(datarow, uuid + 'write');
        data.push(datarow);
        this.props.update(control.key, data, formid);
        if (control.children.filter(x => x.require).length == 0) {
            this.controlVaildationCheck(data)
        }
        var show = this.state.isShow;
        show[uuid] = false;

        this.setState({ isShow: show });
        this.forceUpdate();
    }
    GenerateDataJson(control, DataJson) {

        for (var index = 0; index < control.length; index++) {
            if (control[index].haschildren && control[index].type != 'grid' && control[index].type != 'dashboard' && control[index].type != 'multiselect') {
                this.GenerateDataJson(control[index].children, DataJson);
                // this.props.update(control[index].key, DataJson[control[index].key], storekey);
            } else {
                if (control[index].type == 'checkbox') {
                    DataJson[control[index].key] = false;

                } else if (control[index].type == 'grid') {
                    DataJson[control[index].key] = [];
                }
                else if (control[index].type == 'list') {
                    DataJson[control[index].key] = [];
                }
                else if (control[index].type == 'multiselect') {
                    DataJson[control[index].key] = [];
                }
                else if (control[index].type == 'date'
                    || control[index].type == 'number'
                    || control[index].type == 'googleplaces'
                ) {
                    DataJson[control[index].key] = null;
                } else if (control[index].type == 'label') {
                    if (control[index].viewtype != 'name') {
                        DataJson[control[index].key] = "";
                    }
                }
                else {
                    DataJson[control[index].key] = '';
                }
                // this.props.update(control[index].key, DataJson[control[index].key], storekey);
            }
        }


    }
    DeleteRow() {

        const { formid, control } = this.props;
        const { rowId } = this.state;

        var data = Array.isArray(this.state.data) ? this.state.data : [];
        data = data.filter(row => row.id !== rowId);
        this.props.update(control.key, data, formid);

        var show = this.state.isShow;
        delete show[rowId];
        this.setState({ isShow: show });
        this.forceUpdate();
    }
    togglePanel(rowId) {
        var show = this.state.isShow;
        show[rowId] = !show[rowId];

        this.setState({ isShow: show });
    }
    openModal() {


        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }

    closeModal(deleteConfirm) {

        this.setState({ modalIsOpen: false });
        if (deleteConfirm) {
            if (this.props.control.viewtype == 'list') {
                this.Save(true);
            } else {
                this.DeleteRow();
            }
        }
    }
    Edit(row) {
        this.props.resetData(row, this.state.AddEditForm.Id + "write");
        this.setState({ _opened: true, AddEditFormModelJson: ControlService().deepcopy(row) })
    }
    toggleAddForm() {
        if (this.state.AddEditForm) {
            //this.state._opened = !this.state._opened;
            this.setState({ _opened: !this.state._opened, AddEditFormModelJson: ControlService().deepcopy(this.state.AddEditForm.ModelJson) })

            this.props.resetData(this.state.AddEditForm.ModelJson, this.state.AddEditForm.Id + "write");
        }
    }
    isDisabled() {
        var formvalid = true;

        const formvalidation = this.props.data[this.state.AddEditForm.Id + "write_validation"]
        if (formvalidation) {
            var arr = [];
            Object.keys(formvalidation).forEach(
                (key) => {
                    const value = formvalidation[key] ? formvalidation[key] : {};
                    arr.push({ "key": key, "value": value.status, "control": value.control });
                }
            );
            const isValid = arr.filter(item => item.value == 'fail');
            //if (arr.length > 0 && isValid.length == 0 && this._controlService.formvalid == false)
            if (arr.length == 0) {
                // formvalid = true;
                // this.failedItems = [];
            } else {
                if (arr.length > 0 && isValid.length == 0) {
                    // formvalid = true;
                    //   this.failedItems = [];
                }
                else {
                    //   if (Array.isArray(isValid))
                    //     this.failedItems = isValid;
                    formvalid = false;
                }
            }
        }
        return !formvalid;
    }
    Save(isDelete) {

        var { control, formid } = this.props;
        this.setState({ isApiCalling: true });
        var data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : [];
        let uuid = ""
        if (this.state.rowId) {
            if (isDelete) {
                let action = control.CustomAction.find(item => item.ActionType == 'delete');
                if (action.enablelogdelete) {
                    control.enablelog = true;
                    control.logdescription = action.logdescriptiondelete;
                }
                data[control.key] = data[control.key].filter(row => row.id !== this.state.rowId);
            } else {
                let action = control.CustomAction.find(item => item.ActionType == 'edit');
                data[control.key] = data[control.key].map(item => {
                    if (item.id === this.state.rowId) {
                        item = this.props.data[this.state.AddEditForm.Id + "write"];
                    }
                    return item;
                })
                if (action.enablelogupdate) {
                    control.enablelog = true;
                    control.logdescription = action.logdescriptionupdate;
                }
            }
        } else {
            var datarow = {};
            datarow = this.props.data[this.state.AddEditForm.Id + "write"]// this.state.AddEditForm.ModelJson;
            uuid = uuidv4();

            let action = control.CustomAction.find(item => item.ActionType == 'edit');
            datarow["id"] = uuid;
            data[control.key].push(datarow);
            if (action.enablelogupdate) {
                control.enablelog = true;
                control.logdescription = action.logdescriptioncreate;
            }
        }

        //this.props.resetData(datarow, uuid + this.props.action);

        //var show = this.state.isShow;
        //show[uuid] = false;
        let apiparam = {};

        var updateparamlist = control.updateparamlist ? control.updateparamlist : [];
        updateparamlist.forEach(option => {
            apiparam[option.key] = option.value;
        })
        // this.setState({ isShow: show });
        ControlService().ServiceRequest(control.updateApi, apiparam, control, this.props.token, JSON.stringify(data))
            .then(res => {

                var _data = this.props.data[formid] ? this.props.data[formid][control.key] : [];
                if (control.viewtype == 'list') {
                    this.storeCustomCardsData(_data);
                }
                // this.props.resetData(data, formid)
                // this.props.update(control.key, data[control.key], formid);
                if (this.state._opened) {
                    this.setState({ _opened: false, isApiCalling: false, CustomCardsData: _data })
                } else {
                    this.setState({ isApiCalling: false, CustomCardsData: _data });
                }
                if (res.status == "success") {
                    if (this.state.rowId) {
                        toast.success(<Message icon={control.successmsgicon} title={control.successmsgtitle} message={control.successmsgtext} type="success" />)
                    } else {
                        toast.success(<Message icon={control.updatemsgicon} title={control.updatemsgtitle} message={control.updatemsgtext} type="success" />)
                    }
                }
                if (control.showformonpage) {
                    this.setState({ AddEditFormModelJson: ControlService().deepcopy(this.state.AddEditForm.ModelJson) })

                    this.props.resetData(this.state.AddEditForm.ModelJson, this.state.AddEditForm.Id + "write");
                }
            })
            .catch(err => {
                this.setState({ isApiCalling: false });
                toast.error(<Message message={err.message} type="error" />)
                console.log(err.message);
            });
    }
    renderFormUICard(data) {
        return (
            data.cameoCardUniqueKey ? <div className="row">
                {
                    this.state.CardForm.controls.map(ctrl => {
                        return (ControlService().renderControls(ctrl, 'write', data.cameoCardUniqueKey))
                    })
                }
            </div>
                : null
        )
    }
    renderCards(control, col) {
        return (
            this.state.CardForm ?
                this.renderFormUICard(col)
                : null

        )
    }
    sortedList() {
        var data = Array.isArray(this.state.data) ? this.state.data : [];

        if (this.props.control.enablesorting && this.state.sortedfield && this.state.sortedfield.key) {

            if (this.state.sortedfield.type === 'desc') {
                return _.orderBy(data, [this.state.sortedfield.key], ['desc'])
            } else {
                return _.orderBy(data, [this.state.sortedfield.key], ['asc'])
            }
        } else {
            return data;
        }
    }
    render() {

        var { control, action, formid } = this.props;
        const { data } = this.state;

        const { Iscontrolladded, sidebar, isApiCalling, CustomCardsData, sortedfield } = this.state;

        if (control.enablemultiview) {
            control.isaccordion = true;
            control.children = [];
            control.viewtype = 'list';
        }
        const customStyles = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)'
            }
        };
        if (control.viewtype == 'form') {
            return (
                <div className="card mb-2">
                    <div className="card-header">
                        {action == 'write' ?
                            <div className="d-flex">
                                {data && data.length > 0 ?
                                    <i className="text-primary fa fa-check-square-o pr-2"></i>
                                    : null}
                                <div>
                                    {control.label}
                                    {control.require &&
                                        <sup className="text-danger font-weight-bold">*</sup>
                                    }
                                </div>
                                {control.showcount &&
                                    <div className="d-flex align-items-center position-absolute right pr-3">
                                        <span className="text-primary pr-2">{control.countlabel ? control.countlabel : "Total Count"}</span>
                                        <div>{Array.isArray(data) ? data.length.toString() : "0"}</div>
                                    </div>
                                }
                            </div>
                            :
                            (
                                <div className="d-flex">
                                    <React.Fragment>
                                        {
                                            data && data.length > 0 ?
                                                <i className="text-primary fa fa-check-square-o pr-2"></i>
                                                : null
                                        }
                                        {
                                            action == 'edit' ?
                                                <span className="editebl-input" >{control.label}<i className="fa fa-pencil pointer" aria-hidden="true" onClick="_controlService._toggleSidebar('id',control.id)"></i></span>
                                                : null
                                        }
                                    </React.Fragment>
                                </div>
                            )
                        }
                    </div>
                    <div className="card-body">
                        {
                            control.refresh == true &&
                            <RefreshApiFields formid={formid} control={control} action={action} />
                            // <React.Fragment >
                            //     <button className="btn btn-outline-primary" onClick={(e) => { e.preventDefault(); this.Refresh() }} title="Refresh grid binding field details">
                            //         <i className="fa fa-refresh" aria-hidden="true"></i>
                            //     </button>
                            //     {this.state.refreshMessage && <small className={"ml-2 " + (this.state.refreshMessage == "Refresh completed!" ? "text-success" : "text-danger")}>{this.state.refreshMessage}</small>}
                            // </React.Fragment>
                        }
                        {Iscontrolladded ?
                            <React.Fragment>
                                {
                                    Array.isArray(data) && data.length > 0 ? data.map((row, index) => {
                                        return (
                                            <div key={row.id} className="card mb-1">
                                                <div className="card-header d-flex align-items-center pointer" onClick={() => this.togglePanel(row.id)}>
                                                    {control.headerfield ? <div>{row[control.headerfield]}</div> : null}
                                                    {
                                                        this.state.isShow[row.id] ? <span className="ml-auto pl-2 pr-3"><i className="fa fa-angle-down" aria-hidden="true"></i></span>
                                                            : <span className="ml-auto pl-2 pr-3"> <i className="fa fa-angle-up" aria-hidden="true"></i></span >
                                                    }
                                                    {control.enableUpDown &&
                                                        <>
                                                            {index > 0 &&
                                                                <span class="ml-2 mr-2">
                                                                    <a className="pointer" title="Up" onClick={(e) => { e.stopPropagation(); this.MoveRow(row.id, false) }}><i className="fa fa-arrow-up"></i></a>
                                                                </span>
                                                            }
                                                            {index < (data.length - 1) &&
                                                                <span class="ml-2 mr-3">
                                                                    <a className="pointer" title="Up" onClick={(e) => { e.stopPropagation(); this.MoveRow(row.id, true) }}><i className="fa fa-arrow-down"></i></a>
                                                                </span>
                                                            }
                                                        </>
                                                    }
                                                    {!control.readonly &&
                                                        <button aria-label='Delete' className="pointer btn-no" onClick={(e) => {e.preventDefault(); e.stopPropagation(); this.setState({ rowId: row.id }); this.openModal() }}><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                                    }
                                                </div>
                                                <div className="card-body" hidden={this.state.isShow[row.id]} >
                                                    <div className="row">
                                                        {
                                                            control.children.map((ctrl) => {
                                                                return (
                                                                    ControlService().renderControls(ctrl, 'write', row.id)
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }) : renderNoDataImage(control)
                                }
                            </React.Fragment>
                            :
                            <React.Fragment>
                                {this.callAddControll()}
                            </React.Fragment>
                        }
                        {(!control.Maxrow || data.length < control.Maxrow) && control.children.length > 0 && !control.readonly ?
                            <div className="pt-3 text-right" >
                                {action == 'write' && sidebar == false ?
                                    <React.Fragment>
                                        {this.state.validationFailed &&
                                            <small className="pr-2 text-danger">
                                                * Please fill out all mandatory fields.
                                            </small>}
                                        <button className="btn btn-round btn-outline-primary" onClick={(e) => { e.preventDefault(); this.Addrow(control, formid) }}>
                                            <i className="fa fa-plus pr-md-1"></i> <span className="d-none d-md-inline">{control.addnewlabel ? control.addnewlabel : 'Add New'}</span>
                                        </button >
                                    </React.Fragment>
                                    : null}
                            </div>
                            : null}

                    </div>
                    <Loading token={this.props.token} enable={isApiCalling} class="isParent" />
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={() => this.afterOpenModal()}
                        onRequestClose={() => this.closeModal()}
                        style={customStyles}
                        ariaHideApp={false}
                        overlayClassName='cameo'
                        shouldCloseOnOverlayClick={false}
                    >

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">Are you sure want to delete?</div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-primary" onClick={() => { this.closeModal(true) }}>Yes</button>
                            <button type="button" className="btn btn-outline-primary" onClick={() => { this.closeModal(false) }}>No</button>
                        </div>
                    </Modal>
                </div>
            )
        } else if (control.viewtype == 'list') {
            return (
                <div className="" >
                    <div className={"custom-sidebar-outer " + (this.state._opened ? 'sidebar-open' : null)}>
                        <div className="custom-sidebar">
                            <div className="custom-sidebar-header d-flex align-items-center">
                                {this.state.AddEditForm &&

                                    <div className="d-flex justify-content-between">

                                        <div className="h5 p-3 m-0">{this.state.AddEditForm.Formname}</div>


                                    </div>}
                                <i className="fa fa-times fa-lg ml-auto" onClick={(() => this.setState({ _opened: !this.state._opened }))}></i>
                            </div>
                            <div className="custom-sidebar-body 3">
                                <Loading token={this.props.token} enable={isApiCalling} class="isParent" />

                                {(this.state.AddEditForm && this.state._opened) &&
                                    <div className="container-fluid" >

                                        <DynamicformInit key={this.state.AddEditForm.Id + 'write'}
                                            formid={null}
                                            dataid={''}
                                            formui={this.state.AddEditForm}
                                            datamodel={this.state.AddEditFormModelJson}
                                            access={'write'}
                                            pageparams={{}}
                                            authtoken={this.props.token}
                                        />

                                        <div className="pt-3 text-right">
                                            <button className="btn btn-outline-primary" disabled={this.isDisabled()} onClick={(e) => { e.stopPropagation(); this.Save() }}>Save</button>
                                        </div>
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                    {control.showformonpage ?
                        <div className="container-fluid" >
                            <DynamicformInit key={this.state.AddEditForm.Id + 'write'}
                                formid={null}
                                dataid={''}
                                formui={this.state.AddEditForm}
                                datamodel={this.state.AddEditFormModelJson}
                                access={'write'}
                                pageparams={{}}
                                authtoken={this.props.token}
                            />

                            <div className="pt-3 text-right">
                                <button className="btn btn-outline-primary" disabled={this.isDisabled()} onClick={(e) => { e.stopPropagation(); this.Save() }}>Save</button>
                            </div>
                        </div>
                        : !control.readonly ?
                            <div className="text-right" >
                                <React.Fragment>
                                    {this.state.validationFailed &&
                                        <small className="pr-2 text-danger">
                                            * Please fill out all mandatory fields.
                                        </small>}
                                    <button className="btn btn-round btn-outline-primary" onClick={(e) => { e.stopPropagation(); this.setState({ rowId: null, Iscontrolladded: false }); this.toggleAddForm() }} >
                                        <i className="fa fa-plus pr-md-1"></i><span className="d-none d-md-inline">{control.addnewlabel ? control.addnewlabel : 'Add New'}</span>
                                    </button>
                                </React.Fragment>
                            </div>
                            : null
                    }
                    {control.showcount &&
                        <div className="d-flex align-items-center position-absolute right pr-3">
                            <span className="text-primary pr-2">{control.countlabel ? control.countlabel : "Total Count"}</span>
                            <div>{Array.isArray(data) ? data.length.toString() : "0"}</div>
                        </div>
                    }
                    {

                        Array.isArray(CustomCardsData) && CustomCardsData.length > 0 ? CustomCardsData.map((row, index) => {
                            return (
                                <div className='position-relative' key={JSON.stringify(row)}>
                                    <div key={index} className="grid-list">
                                        {this.renderCards(control, row)}
                                        <div className="grid-list-custom-action">
                                            {control.CustomAction.map((act, idx) => {
                                                return (<React.Fragment key={idx}>
                                                    {
                                                        act.ActionType === "edit" &&
                                                        <button aria-label={act.ActionName ? act.ActionName : 'Edit'} className={"btn btn-sm btn-" + act.buttontype} onClick={(e) => {e.preventDefault(); e.stopPropagation(); this.setState({ rowId: row.id }); this.Edit(row) }}>
                                                            {(act.webnametype == "icononly" || act.webnametype == "nameicon") &&
                                                                <i className={"fa-lg " + act.WebIcon + (act.webnametype == "nameicon" ? " mr-2" : "")} >
                                                                </i>}
                                                            {(act.webnametype == "nameicon" || act.webnametype == "nameonly") &&
                                                                <span >{act.ActionName}</span>}
                                                        </button>
                                                    }

                                                    {
                                                        act.ActionType == 'delete' &&
                                                        <button aria-label={act.ActionName ? act.ActionName : 'Delete'} className={"btn btn-sm btn-" + act.buttontype} onClick={(e) => {e.preventDefault(); e.stopPropagation(); this.setState({ rowId: row.id }); this.openModal() }}>
                                                            {(act.webnametype == "icononly" || act.webnametype == "nameicon") &&
                                                                <i className={"fa-lg " + act.WebIcon + (act.webnametype == "nameicon" ? " mr-2" : "")} >
                                                                </i>}
                                                            {(act.webnametype == "nameicon" || act.webnametype == "nameonly") &&
                                                                <span >{act.ActionName}</span>}
                                                        </button>
                                                    }
                                                </React.Fragment>)
                                            })}

                                        </div>
                                    </div>
                                </div>
                            )
                        })
                            : renderNoDataImage(control)
                    }
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={() => this.afterOpenModal()}
                        onRequestClose={() => this.closeModal()}
                        style={customStyles}
                        overlayClassName='cameo'
                        shouldCloseOnOverlayClick={false}
                    >

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">Are you sure want to delete?</div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-primary" onClick={() => { this.closeModal(true) }}>Yes</button>
                            <button type="button" className="btn btn-outline-primary" onClick={() => { this.closeModal(false) }}>No</button>
                        </div>
                    </Modal>
                </div>
            )
        } else if (control.viewtype == 'Tree View') {
            return (
                <div onClick={() => this.togglePanel(control.id)}>
                    <div className={control.labelClass} style={{color:control.labelColor}}>
                    {control.label}
                    {control.require &&
                        <sup className="text-danger font-weight-bold">*</sup>
                    }
                    </div>
                    <div className="2">
                        {
                            control.refresh == true &&
                            <RefreshApiFields formid={formid} control={control} action={action} />
                            // <React.Fragment >
                            //     <button className="btn btn-outline-primary" onClick={(e) => { e.preventDefault(); this.Refresh() }} title="Refresh grid binding field details">
                            //         <i className="fa fa-refresh" aria-hidden="true"></i>
                            //     </button>
                            //     {this.state.refreshMessage && <small className={"ml-2 " + (this.state.refreshMessage == "Refresh completed!" ? "text-success" : "text-danger")}>{this.state.refreshMessage}</small>}
                            // </React.Fragment>
                        }
                        {Iscontrolladded ?
                            <React.Fragment>
                                {
                                    Array.isArray(data) && data.length > 0 ? data.map((row, index) => {
                                        return (
                                            <div key={row.id} className="grid-tree" style={{borderColor:control.borderColor ? control.borderColor : "#ddd"}}>
                                                <div className='h-line' style={{backgroundColor:control.borderColor ? control.borderColor : "#ddd"}}></div>
                                                <div className={control.headerClass+" grid-tree-header d-flex align-items-center"} style={{color:control.headerColor}}>
                                                    {control.headerfield ? <div className='mr-3'>{row[control.headerfield]}</div> : null}
                                                    
                                                    <div className='grid-tree-control ml-auto' style={{fontSize:16}}>
                                                    {
                                                        this.state.isShow[row.id] ? <span className=" pl-2 pr-3 pointer" onClick={() => this.togglePanel(row.id)}><i className="fa fa-plus" aria-hidden="true"></i></span>
                                                            : <span className="ml-auto pl-2 pr-3 pointer" onClick={() => this.togglePanel(row.id)}> <i className="fa fa-minus" aria-hidden="true"></i></span >
                                                    }
                                                    {control.enableUpDown &&
                                                        <>
                                                            {index > 0 &&
                                                                <span class="ml-2 mr-2"  style={{fontSize:16}}>
                                                                    <a className="pointer" title="Up" onClick={(e) => { e.stopPropagation(); this.MoveRow(row.id, false) }}><i className="fa fa-arrow-up"></i></a>
                                                                </span>
                                                            }
                                                            {index < (data.length - 1) &&
                                                                <span class="ml-2 mr-3"  style={{fontSize:16}}>
                                                                    <a className="pointer" title="Up" onClick={(e) => { e.stopPropagation(); this.MoveRow(row.id, true) }}><i className="fa fa-arrow-down"></i></a>
                                                                </span>
                                                            }
                                                        </>
                                                    }
                                                    
                                                    {!control.readonly &&
                                                        <button aria-label='Delete' className="pointer btn-no"  style={{fontSize:16}} onClick={(e) => {e.preventDefault(); e.stopPropagation(); this.setState({ rowId: row.id }); this.openModal() }}><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                                    }
                                                    </div>
                                                </div>
                                                <div className="" hidden={this.state.isShow[row.id]} >
                                                    <div className="row">
                                                        {
                                                            control.children.map((ctrl) => {
                                                                return (
                                                                    ControlService().renderControls(ctrl, 'write', row.id)
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }) : renderNoDataImage(control)
                                }
                            </React.Fragment>
                            :
                            <React.Fragment>
                                {this.callAddControll()}
                            </React.Fragment>
                        }
                        {(!control.Maxrow || data.length < control.Maxrow) && control.children.length > 0 && !control.readonly ?
                            <div className="grid-tree-add-item" >
                                {action == 'write' && sidebar == false ?
                                    <React.Fragment>
                                        {this.state.validationFailed &&
                                            <small className="pr-2 text-danger">
                                                * Please fill out all mandatory fields.
                                            </small>}
                                        <button className="btn btn-round btn-outline-primary" onClick={(e) => { e.preventDefault(); this.Addrow(control, formid) }}>
                                            <i className="fa fa-plus pr-md-1"></i> <span className="d-none d-md-inline">{control.addnewlabel ? control.addnewlabel : 'Add New'}</span>
                                        </button >
                                    </React.Fragment>
                                    : null}
                            </div>
                            : null}

                    </div>
                    <Loading token={this.props.token} enable={isApiCalling} class="isParent" />
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={() => this.afterOpenModal()}
                        onRequestClose={() => this.closeModal()}
                        style={customStyles}
                        ariaHideApp={false}
                        overlayClassName='cameo'
                        shouldCloseOnOverlayClick={false}
                    >

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">Are you sure want to delete?</div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-primary" onClick={() => { this.closeModal(true) }}>Yes</button>
                            <button type="button" className="btn btn-outline-primary" onClick={() => { this.closeModal(false) }}>No</button>
                        </div>
                    </Modal>
                </div>
            )
        } else {
            return (
                <div className="card mb-2">
                    <div className="card-header">
                        <React.Fragment>
                            <div className="d-flex align-items-center">
                                {data && data.length > 0 ? <i className="text-primary fa fa-check-square-o pr-2"></i> : null}
                                <div>
                                    {control.label}
                                    {control.require &&
                                        <sup className="text-danger font-weight-bold">*</sup>
                                    }
                                </div>
                                {control.showcount &&
                                    <div className="d-flex align-items-center position-absolute right pr-3">
                                        <span className="text-primary pr-2">{control.countlabel ? control.countlabel : "Total Count"}</span>
                                        <div>{Array.isArray(data) ? data.length.toString() : "0"}</div>
                                    </div>
                                }
                            </div>
                        </React.Fragment>
                    </div>
                    <div className="card-body">
                        {
                            control.refresh == true &&
                            <RefreshApiFields formid={formid} control={control} action={action} />
                        }
                        {control.viewtype == 'grid' && Array.isArray(data) && Iscontrolladded ?
                            <React.Fragment>
                                <div className="table-responsive">
                                    <table className="table table-sm grid-table">
                                        <tbody>
                                            <tr>
                                                {control.children.map((childctrl) => {
                                                    return (
                                                        <th key={childctrl.id} className={(childctrl.isboldheader ? ' font-weight-bold ' : ' font-weight-normal ') + ' ' + (childctrl.columnalign ? 'text-' + childctrl.columnalign : ' ')}>
                                                            {childctrl.placeholder}
                                                            {(control.enablesorting && childctrl.placeholder) &&
                                                                <React.Fragment>
                                                                    {
                                                                        sortedfield && sortedfield.key === childctrl.key ?
                                                                            sortedfield.type === 'asc' ?
                                                                                <i className="fa fa-sort-asc pl-2 font-weight-bold" aria-hidden="true" onClick={() => this.setState({ sortedfield: { key: childctrl.key, type: 'desc' } })}></i>
                                                                                :
                                                                                <i className="fa fa-sort-desc pl-2 font-weight-bold" aria-hidden="true" onClick={() => this.setState({ sortedfield: { key: childctrl.key, type: 'asc' } })}></i>
                                                                            :
                                                                            <i className="fa fa-sort pl-2 font-weight-normal" aria-hidden="true" onClick={() => this.setState({ sortedfield: { key: childctrl.key, type: 'asc' } })}></i>
                                                                    }
                                                                </React.Fragment>
                                                            }
                                                        </th>
                                                    )
                                                })}
                                                <th></th>
                                            </tr>
                                            {
                                                this.sortedList().map((row) => {
                                                    return (
                                                        <tr key={row.id} >
                                                            {control.children.map((ch) => {
                                                                return (
                                                                    <td key={ch.id} className={(ch.columnalign ? 'text-' + ch.columnalign : ' ')} style={{ width: ch.width && ch.width !== 'auto' ? (100 / (12 / ch.width)) + '%' : 'auto' }}>
                                                                        {/* {ControlService().renderControls(ch, 'write', row.id)} */}
                                                                        <DynamicFormControls key={ch.id} formid={row.id} control={ch} action={'write'} noclass={true} />
                                                                    </td>
                                                                )
                                                            })}
                                                            {control.enableUpDown &&
                                                                <>
                                                                    {index > 0 &&
                                                                        <span class="ml-2 mr-2">
                                                                            <a className="pointer" title="Up" onClick={(e) => { e.stopPropagation(); this.MoveRow(row.id, false) }}><i className="fa fa-arrow-up"></i></a>
                                                                        </span>
                                                                    }
                                                                    {index < (data.length - 1) &&
                                                                        <span class="ml-2 mr-3">
                                                                            <a className="pointer" title="Up" onClick={(e) => { e.stopPropagation(); this.MoveRow(row.id, true) }}><i className="fa fa-arrow-down"></i></a>
                                                                        </span>
                                                                    }
                                                                </>
                                                            }
                                                            {!control.readonly &&
                                                                <td className="text-center align-middle" width="20">
                                                                    <button aria-label='Delete' className="pointer btn-no" onClick={(e) => {e.preventDefault(); e.stopPropagation(); this.setState({ rowId: row.id }); this.openModal() }}><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                                                </td>
                                                            }
                                                        </tr >
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table >
                                </div>
                                {(!control.Maxrow || data.length < control.Maxrow) && control.children.length > 0 && !control.readonly ?
                                    <div className="pt-3 text-right" >
                                        {action == 'write' && sidebar == false ?
                                            <React.Fragment>
                                                {this.state.validationFailed &&
                                                    <small className="pr-2 text-danger">
                                                        * Please fill out all mandatory fields.
                                                    </small>}
                                                <button className="btn btn-outline-primary" onClick={(e) => { e.preventDefault(); this.Addrow(control, formid) }}>
                                                    <i className="fa fa-plus mr-1"></i>
                                                    {control.addnewlabel ? control.addnewlabel : 'Add New'}
                                                </button>
                                            </React.Fragment>
                                            : null}
                                    </div>
                                    : null}
                            </React.Fragment>
                            : data && Array.isArray(data) && Iscontrolladded ?
                                <React.Fragment>
                                    <div className="table-responsive">
                                        <table className="table table-sm">
                                            {control.children.map((childctrl) => {
                                                return (
                                                    <tr key={childctrl.id}>
                                                        <td><strong>{childctrl.placeholder}</strong></td>
                                                        {Array.isArray(data) && data.map((row) => {
                                                            return (
                                                                <td key={row.id}>
                                                                    {/* {ControlService().renderControls(childctrl, 'write', row.id)} */}
                                                                    <DynamicFormControls key={childctrl.id} formid={row.id} control={childctrl} action={'write'} noclass={true} />
                                                                </td>
                                                            )
                                                        })}
                                                    </tr >
                                                )
                                            })}
                                        </table >
                                    </div>
                                    {(!control.Maxrow || data.length < control.Maxrow) && control.children.length > 0 && !control.readonly ?
                                        <div className="pt-3 text-right" >
                                            {action == 'write' && sidebar == false ?
                                                <React.Fragment>
                                                    {this.state.validationFailed &&
                                                        <small className="pr-2 text-danger">
                                                            * Please fill out all mandatory fields.
                                                        </small>}
                                                    <button className="btn btn-outline-primary" onClick={(e) => { e.preventDefault(); this.Addrow(control, formid) }}>
                                                        <i className="fa fa-plus mr-1"></i>
                                                        {control.addnewlabel ? control.addnewlabel : 'Add New'}
                                                    </button>
                                                </React.Fragment>
                                                : null}
                                        </div>
                                        : null}
                                </React.Fragment>
                                : renderNoDataImage(control)
                        }
                    </div>
                    <Loading token={this.props.token} enable={isApiCalling} class="isParent" />
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={() => this.afterOpenModal()}
                        onRequestClose={() => this.closeModal()}
                        style={customStyles}
                        overlayClassName='cameo'
                        shouldCloseOnOverlayClick={false}
                    >

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">Are you sure want to delete?</div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-primary" onClick={() => { this.closeModal(true) }}>Yes</button>
                            <button type="button" className="btn btn-outline-primary" onClick={() => { this.closeModal(false) }}>No</button>
                        </div>
                    </Modal>
                </div>
            )
        }
    }
}

export default connect(
    mapStateToProps, bindAction
)(GridUI);